import nonEmpty from '../utils/nonEmpty';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const ACTIVITIES_POST_TOPICS_TOPICS = gql(`
  fragment activitiesPostTopics_topics on Topic {
    id
    name
  }
`);

const activitiesPostTopics = (
  postTopics:
    | (DocumentType<typeof ACTIVITIES_POST_TOPICS_TOPICS> | null)[]
    | null = [],
) => {
  const topics = postTopics?.filter(nonEmpty);
  if (!topics) {
    return null;
  }

  const firstTopic = topics[0];
  if (!firstTopic) return null;

  if (topics.length <= 2) {
    return `in: ${topics.map((topic) => topic.name).join(', ')}`;
  }

  return `in: ${firstTopic.name} and ${topics.length - 1} more`;
};

activitiesPostTopics.fragments = {
  topics: ACTIVITIES_POST_TOPICS_TOPICS,
};

export default activitiesPostTopics;
